import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/homePage';
import { CardInstructions } from './pages/cardInstructions';
import { TimerAppPage } from './pages/timerApp/timerAppPage';
import { OrganizationListPage } from './pages/orgs/organizationListPage';
import { OrganizationPage } from './pages/orgs/organizationPage';

import { TeamPage } from './pages/team/teamPage';
import './app.css';

import { AdminPage } from './pages/admin/adminPage';
import { AddMemberPage } from './pages/team/addMemberPage';
import { UpdateSponsorPage } from './pages/orgSeason/updateSponsorPage';

import { OrganizationAdminPage } from './pages/orgs/organizationAdminPage';
import { OrderFormPage } from './pages/payment/orderFormPage';
import { CheckoutStatusPage } from './pages/payment/checkoutStatusPage';
import { UpdateUserPage } from './pages/admin/updateUserPage';
import { Footer } from './shared/footer';
import { Header } from './shared/header';
import { Box, Grid } from '@mui/material';
import { MembersPage } from './pages/member/membersPage';
import { OrgSeasonPage } from './pages/orgSeason/orgSeasonPage';
import { OrgSeasonAdminPage } from './pages/orgSeason/orgSeasonAdminPage';
import { ProfileCapturePage } from './pages/orgSeason/profileCapturePage';
import { CardDataFormPage } from './pages/member/cardDataFormPage';
import { AthletePage } from './pages/athlete/athletePage';
import { RunnerPage } from './pages/runner/runnerPage';
import { RacePage } from './pages/runner/racePage';
import { GamePage } from './pages/team/gamePage';
import { SponsorPage } from './pages/sponsorPage';
import { ManageAthletePage } from './pages/athlete/manageAthletePage';
import { AddOrganizationPage } from './pages/orgs/addOrganizationPage';
import { CreateProgramPage } from './pages/customPrograms/createProgramPage';
import { ManageProgramPage } from './pages/customPrograms/manageProgramPage';
import { TeamAdminPage } from './pages/team/teamAdminPage';
import { UploadMyImagePage } from './pages/member/uploadMyImagePage';
import { OnlineProgramPage } from './pages/team/onlineProgramPage';
import { Playoff } from './pages/playoff';
import { TinyRedirect } from './pages/tinyRedirect';
import { AnalyticsTracker } from './analyticsTracker';
import CameraRecorder from './motion-detect/cameraRecorder';
import { AiVisionUploadPage } from './pages/aiVisionUploadPage';



export function App() {
  return (
    <>
    <BrowserRouter>
      <Header />
      <AnalyticsTracker />
      <Box className='mainContent'>
        <Grid container spacing={2}>
          <Grid item xs={1} />

          <Grid item xs={10} >
            
              <Routes>
                <Route path='/' element={<HomePage />} />
                <Route path='/sponsor' element={<SponsorPage />} />
                <Route path='/tiny/:slug/:teamCode' element={<TinyRedirect />} />
                <Route path='/playoff' element={<Playoff />} />
                <Route path='/race' element={<RacePage />} />
                <Route path='/trading-card/instructions' element={<CardInstructions />} />
                <Route path='/timer' element={<TimerAppPage />} />
                <Route path='/camera-recorder' element={<CameraRecorder />} />
                <Route path='/ai-vision-upload' element={<AiVisionUploadPage />} />
                
                <Route path='/orgseason/:orgSeasonId/timer' element={<TimerAppPage />} />
                <Route path='/order' element={<OrderFormPage />} />
                <Route path='/checkout-status' element={<CheckoutStatusPage />} />
                <Route path='/orgs' element={<OrganizationListPage />} />
                <Route path='/orgs/new' element={<AddOrganizationPage />} />
                <Route path='/orgs/:orgId' element={<OrganizationPage />} />
                <Route path='/orgs/:orgId/admin' element={<OrganizationAdminPage />} />
                <Route path='/orgseason/:orgSeasonId' element={<OrgSeasonPage />} />
                <Route path='/orgseason/:orgSeasonGuid/team/:teamGuid' element={<TeamPage />} />
                <Route path='/orgseason/:orgSeasonGuid/team/:teamGuid/admin' element={<TeamAdminPage />} />
                <Route path='/orgseason/:orgSeasonId/team/:teamId/game' element={<GamePage />} />
                <Route path='/orgseason/:orgSeasonGuid/team/:teamGuid/program' element={<ManageProgramPage />} />
                <Route path='/program/online/:programGuid' element={<OnlineProgramPage />} />
                <Route path='/orgseason/:orgSeasonGuid/team/:teamGuid/program/form' element={<CreateProgramPage />} />
                <Route path='/orgseason/:orgSeasonGuid/team/:teamGuid/program/form/:programGuid' element={<CreateProgramPage />} />
                
                
                <Route path='/orgseason/:orgSeasonId/team/:teamId/add' element={<AddMemberPage />} />
                
                <Route path='/card-data/code/:secCode' element={<CardDataFormPage />} />
                <Route path='/upload-my-image' element={<UploadMyImagePage />} />

                <Route path='/orgseason/:orgSeasonId/member/:memberId' element={<MembersPage />} />
                <Route path='/orgseason/:orgSeasonId/team/:teamId/member/:memberId' element={<MembersPage />} />
                <Route path='/orgseason/:orgSeasonGuid/photo-capture' element={<ProfileCapturePage />} />
                <Route path='/orgseason/:orgSeasonId/sponsor' element={<UpdateSponsorPage />} />
                <Route path='/orgseason/:orgSeasonId/sponsor/:sponsorId' element={<UpdateSponsorPage />} />
                <Route path='/orgseason/:orgSeasonId/admin' element={<OrgSeasonAdminPage />} />
                <Route path='/admin' element={<AdminPage />} />
                <Route path='/user/:userId' element={<UpdateUserPage />} />
                <Route path='/orgSeason/:orgSeasonId/athlete/:athleteGuid' element={<AthletePage />} />
                <Route path='/orgSeason/:orgSeasonId/athlete/:athleteGuid/manage' element={<ManageAthletePage />} />
                <Route path='/orgSeason/:orgSeasonId/runner/:runnerGuid' element={<RunnerPage />} />
              </Routes>
          </Grid>

          <Grid item xs={1} />
        </Grid>
      </Box>
      <Footer />
      </BrowserRouter>
    </>
  );
}


